module.exports = __webpack_public_path__ + "static/media/telegram.67b0e23f.png";